const CustomersList = [
    {
        quote: '"Understated, but unforgettable. It feels like it was made for me', 
        name: "Random Woman", 
        location: "NY, USA", 
        image: "/utils/customer1.svg"
    },
    {
        quote: '"I love the way it makes me feel', 
        name: "Random Man", 
        location: "CA, INDIA", 
        image: "/utils/customer2.jpg"
    },
    {
        quote: '"A perfect blend of style and comfort', 
        name: "Wonder Woman", 
        location: "HY, Hong Kong", 
        image: "/utils/customer3.svg"
    }
]
export default CustomersList;